import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { capitalizeFirstLetter } from 'static_pages/marketing_pages/helpers';

interface Props {
  errors?: string[];
}

function QuestionErrors({ errors }: Props) {
  const { t } = useTranslation();

  return (
    <Box color="red" display="flex" justifyContent="center" textAlign="center">
      {errors !== undefined && (
        <UnorderedList>
          {errors.map((error) => (
            <li key={error}>
              <Box display="flex" alignItems="center">
                <Box as="span" mr={1} lineHeight={1}>
                  <ReportProblemOutlinedIcon fontSize="small" />
                </Box>
                <Typography variant="body1" fontSize={14}>
                  {capitalizeFirstLetter(t(error))}
                </Typography>
              </Box>
            </li>
          ))}
        </UnorderedList>
      )}
    </Box>
  );
}

const UnorderedList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;
`;

export default QuestionErrors;
